import { Helper } from "../../core/util/helper";
import { Grid } from "../../core/components/grid";
import { DropDownList } from "../../core/components/dropDownList";
import { ColorPicker } from "../../core/components/colorPicker";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { SheetEventType } from "../../../siteManagement/sheet";
import { ComponentHelper } from "../../core/util/componentHelper";
import { data } from "../../../typeinfo/jquery/index";
import { DialogHelper } from "../../core/util/dialogHelper";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react";

export default class WeekendSchemaGrid extends React.Component<any, { data: GridItem[] }>{
    private gridOptions: kendo.ui.GridOptions;
    private metaData: Metadata;

    private role = "colorBox";
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
        this.gridOptions = {
            sortable: false,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Name",
                    title: Helper.getTranslation("Standard.Bezeichnung")
                },
                {
                    field: "Colors",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Style.Colors"),
                    template: (item: GridItem) => {
                        return `<div role=${this.role} data-color-1=${item.Color1.replace("#", "")} data-color-2=${item.Color2.replace("#", "") }></div>`;
                    }
                }
            ]
        };
        this.initApp();
    }

    private initApp = async () => {
        const [metaData, _] = await Promise.all([
            Helper.getMetaData("weekendSchema"),
            this.loadGridData()
        ]);
        this.metaData = metaData;
        this.setState({});

    }

    private loadGridData = async () => {
        const data = await HTTPService.get<JsonResultClass<GridItem[]>>("ResourceSettings/GetAllSchemas");
        if (data.Code == 0) {
            this.setState({ data: data.Data }, this.updateGridFields)
        }
    }

    private renderGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            {
                caption: Config.translations.newLabel,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            },
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            },
            {
                caption: Config.translations.deleteLabel,
                type: ToolBarStandardButtonType.DELETE,
                enabled: true
            }
        ];
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.data}
                    options={this.gridOptions}
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                    id="editWeekendSchema"
                />
            </div>
        );
    }

    private onStandardClick = async (type: ToolBarStandardButtonType, dataItem: GridItem) => {

        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                const result = await this.loadSchema(dataItem.Id).catch((reason: any) => {
                    NotificationHelper.showErrorMessage(reason);
                });
                this.openSheet(result, Helper.getTranslation("Field.Ressource.wochenendid") + ": "+ dataItem.Name );
                break;
            case ToolBarStandardButtonType.NEW:
                const schema: WeekendSchema = {
                    Id: null,
                    IsNew: true,
                    IsWatchable: false,
                    IsWatched: false,
                    Note: "",
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    },
                    Translations: [],
                    UseSameColor: true,
                    IndividualFields: {},
                    FirstDayOfWeekend: {
                        Color: "#C0C0C0",
                        Day: Tag.Saturday
                    },
                    SecondDayOfWeekend: {
                        Color: "#C0C0C0",
                        Day: Tag.Sunday
                    }
                };
                this.openSheet(schema, Helper.getTranslation("Field.Ressource.wochenendid"));
                break;
            case ToolBarStandardButtonType.DELETE:
                const deletedSuccessfully = await this.deleteSchema(dataItem.Id);
                if (deletedSuccessfully) {
                    await this.loadGridData();
                }
                break;
        }

    }

    private loadSchema = (id: number) => {
        return new Promise<any>(async (resolve, reject) => {
            const result = await HTTPService.get<JsonResultClass<WeekendSchema>>(`ResourceSettings/GetSchemaById?id=${id}`);
            if (result.Code == 0) {
                resolve(result.Data);
            } else {
                reject(result.Message);
            }
        });
    }

    private openSheet = (schema: WeekendSchema, title: string = "") => {
        const props: WeekendSchemaProps = {
            context: { key1: "entity.Id", keyVal1: schema.Id, contextType: "WeekendSchema" },
            title: title,
            entity: schema,
            metadata: this.metaData,
            dataSources: {},
            isWindow: true,
            delete: this.deleteSchema
        };
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this.loadGridData();            
        });

        sheet.show(() => {
            sheet.mountContent(WeekendSchemaApp, props);
        });
    }

    private deleteSchema = (id: number) => {
        return new Promise<boolean>(async (resolve) => {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
            if (!isOk) {
                resolve(false);
            } else {
                const result = await HTTPService.post<JsonResultClass>(`ResourceSettings/DeleteSchema?id=${id}`);
                if (result.Code == 1) {
                    NotificationHelper.showErrorMessage(result.Message);
                } 
                resolve(result.Code == 0);
            }
        });
    }

    private updateGridFields = () => {
        document.querySelectorAll(`[role="${this.role}"]`).forEach((div: HTMLDivElement) => {
            const color1 = div.getAttribute("data-color-1") as string;
            const color2 = div.getAttribute("data-color-2") as string;
            //div.style.backgroundColor = color1;
            div.style.background = `linear-gradient(to bottom right, ${"#" + color1} 0%, ${"#" + color1} 50%, ${"#" + color2} 50%, ${"#" + color2} 100%)`;
            div.style.borderColor = "#000000";
            div.style.borderStyle = "solid";
            div.style.borderWidth = "1px";
            div.style.height = "25px";
            div.style.padding = "3px 7px";
            div.style.display = "flex";
            div.style.alignItems = "center";
            div.style.justifyContent = "center";
        });
    }

    render() {
        return this.renderGrid();
    }
}

interface GridItem {
    Id: number;
    Name: string;
    Color1: string;
    Color2: string;
}

class WeekendSchemaApp extends React.Component<WeekendSchemaProps, any>{
    common = new AppHelper();
    constructor(props: WeekendSchemaProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }


    renderSchemaEditing = () =>{
        return <WeekendSchemaEditing entity={this.props.entity} onChange={this.handleFieldChange} />;
    }

    private validate = () => {
        if ((!Helper.hasValue(this.props.entity.FirstDayOfWeekend.Day)) && (!Helper.hasValue(this.props.entity.SecondDayOfWeekend.Day))) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.Resource.WeekendSchema.AtLeastOneday"));
            return false;
        }
        if (this.props.entity.FirstDayOfWeekend.Day == this.props.entity.SecondDayOfWeekend.Day) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.Resource.WeekendSchema.SelectDifferent"));
            return false;
        }

        const valid_transaltions = this.props.entity.Translations.filter(f => !Helper.isNullOrEmpty(f.Value));
        if (valid_transaltions.length == 0) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.Report.Question.Messages.TitlesNotTranslated"));
            return false;
        }
        return true;
    }

    save = async () => {
        if (this.validate()) {
            const result = await HTTPService.post<JsonResultClass<WeekendSchema>>("ResourceSettings/SaveSchema", {
                schema: this.props.entity
            });
            if (result.Code === 0) {
                Helper.updateEntity(this.props.entity, result.Data);
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, false);
            this.setState({});
        }
    }

    remove = async () => {
        const isOk = await this.props.delete(this.props.entity.Id);
        if (isOk) {
            General.Sheet.Manager.getTopMostSheet().remove();
        }
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.UseSameColor":
                if (!this.props.entity.UseSameColor && value) {
                    let color = this.props.entity.FirstDayOfWeekend.Color;
                    if (Helper.isNullOrEmpty(color)) {
                        color = this.props.entity.SecondDayOfWeekend.Color;
                    }
                    if (!Helper.isNullOrEmpty(color)) {
                        this.handleFieldChange({ model: "entity.FirstDayOfWeekend.Color" }, color);
                        this.handleFieldChange({ model: "entity.SecondDayOfWeekend.Color"}, color);
                    }
                }

                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props}/>;
    }
}

interface WeekendSchemaProps extends AppBaseProps {
    entity: WeekendSchema;
    delete: (id: number) => Promise<boolean>;
}

interface WeekendSchema extends Entity {
    Id: number;
    Note: string;
    Translations: KeyValuePair<number, string>[];
    UseSameColor: boolean;
    FirstDayOfWeekend: WeekendDay;
    SecondDayOfWeekend: WeekendDay;
}

interface WeekendDay {
    Day: Tag;
    Color: string;
}

enum Tag {
    Sunday = 1,
    Monday = 2,
    Tuesday = 3,
    Wednesday = 4,
    Thursday = 5,
    Friday = 6,
    Saturday = 7
}

class WeekendSchemaEditing extends React.Component<WeekendEditGridProps, any>{
    private factory = ComponentHelper.createFactory();

    private style: React.CSSProperties = {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridTemplateRows: "repeat(3, 45px)"
    };

    private days: KeyValuePair<Tag, string>[] = [{
        Key: Tag.Monday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Monday")
    }, {
        Key: Tag.Tuesday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Tuesday")
    }, {
        Key: Tag.Wednesday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Wednesday")
    }, {
        Key: Tag.Thursday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Thursday")
    }, {
        Key: Tag.Friday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Friday")
    }, {
        Key: Tag.Saturday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Saturday")
    }, {
        Key: Tag.Sunday,
        Value: Helper.getTranslation("Einsatz.MultipleCreation.DayOfWeek.Sunday")
    }];

    private renderLabel = (translationKey: string, raw: number, column: number, alignCenter: boolean) => {
        const style: React.CSSProperties = {
            gridColumn: `${column}/${column + 1}`,
            gridRow: `${raw}/${raw + 1}`,
            display: "flex",
            alignItems: "center"
        };
        if (alignCenter) {
            style.justifyContent = "center";
        }
        return <label style={style}>{Helper.getTranslation(translationKey)}</label>;
    }

    private renderDropDown = (model: string, value: Tag, column: number) => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = value;
        props.dataSource = this.days;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.valueNullIfNotInDS = true;
        props.onChange = (_, value: Tag) => {
            if (typeof value === 'string')
                value = null;
            this.props.onChange({ model: model }, value);
        }
        return (
            <div style={{ padding: "1.5px", gridColumn: `${column}/${column + 1}`, gridRow: "2/3", width: "95%" }}>
                <DropDownList {...props}/>
            </div>
        );
    }

    private renderSingleColorPicker = (model: string, value: string, column: number) => {
        const props = this.factory.getDefaultColorPickerProps();
        props.value = value;
        props.field.random = true
        props.onChange = (_, value: string) => {
            this.props.onChange({ model: model }, value);
        }
        return (
            <div style={{ padding: "1.5px", gridColumn: `${column}/${column + 1}`, gridRow: "3/4", width: "95%" }}>
                <ColorPicker {...props} />
            </div>
        );
    }

    render() {
        let colorPickers = (
            <>
                {Helper.hasValue(this.props.entity.FirstDayOfWeekend.Day) ? this.renderSingleColorPicker("entity.FirstDayOfWeekend.Color", this.props.entity.FirstDayOfWeekend.Color, 2) : null}
                {Helper.hasValue(this.props.entity.SecondDayOfWeekend.Day) ? this.renderSingleColorPicker("entity.SecondDayOfWeekend.Color", this.props.entity.SecondDayOfWeekend.Color, 3) : null}
            </>
        );
        if (this.props.entity.UseSameColor && (Helper.hasValue(this.props.entity.FirstDayOfWeekend.Day) || Helper.hasValue(this.props.entity.SecondDayOfWeekend.Day))) {
            const props = this.factory.getDefaultColorPickerProps();
            props.value = Helper.isNullOrEmpty(this.props.entity.FirstDayOfWeekend.Color) ? this.props.entity.SecondDayOfWeekend.Color : this.props.entity.FirstDayOfWeekend.Color;
            props.field.random = true
            props.onChange = (_, value: string) => {
                this.props.onChange({ model: "entity.FirstDayOfWeekend.Color" }, value);
                this.props.onChange({ model: "entity.SecondDayOfWeekend.Color" }, value);
            }

            colorPickers = (
                <div style={{ padding: "1.5px", gridColumn: "2/4", gridRow: "3/4", width: "95%" }}>
                    <ColorPicker {...props} />
                </div>
            );
        }



        return (
            <div style={this.style}>
                {this.renderLabel("WebSMS.GeneralSettings.Resource.WeekendSchema.First", 1, 2, true)}
                {this.renderLabel("WebSMS.GeneralSettings.Resource.WeekendSchema.Second", 1, 3, true)}

                {this.renderLabel("WebSMS.SLA.TypeOfDay", 2, 1, false)}
                {this.renderDropDown("entity.FirstDayOfWeekend.Day", this.props.entity.FirstDayOfWeekend.Day, 2)}
                {this.renderDropDown("entity.SecondDayOfWeekend.Day", this.props.entity.SecondDayOfWeekend.Day, 3)}

                {(Helper.hasValue(this.props.entity.FirstDayOfWeekend.Day) || Helper.hasValue(this.props.entity.SecondDayOfWeekend.Day)) ? this.renderLabel("Standard.Farbe", 3, 1, false) : null}
                {colorPickers}

            </div>
        );
    }
}

interface WeekendEditGridProps {
    entity: WeekendSchema;
    onChange: (field: { model: string }, value) => void;
}